module.exports = __webpack_public_path__ + "img/pastagens.d23b6e80.svg";